import React from "react";
import { theme } from "../styles/theme";

const SplashScreen = ({ background = "white" }) => {
  // background pode ser "white" ou "primary" (vermelho)
  const bgColor = background === "primary" ? theme.colors.primary : theme.colors.white;
  const textColor = background === "primary" ? theme.colors.white : theme.colors.primary;

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: bgColor,
        color: textColor,
        fontFamily: theme.typography.fontFamily.primary,
        transition: theme.transitions.normal,
      }}
    >
      <img
        src={process.env.PUBLIC_URL + "/logo192.png"}
        alt="Logo Draiva"
        style={{ width: 96, height: 96, marginBottom: theme.spacing.lg, borderRadius: theme.borderRadius.xl }}
      />
      <h1 style={{ fontSize: theme.typography.fontSize['2xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xs, letterSpacing: 1 }}>
        Draiva
      </h1>
      <div style={{ fontSize: theme.typography.fontSize.base, opacity: 0.7, marginBottom: theme.spacing.md, textAlign: 'center', maxWidth: 300 }}>
        A tua carta de condução começa no Draiva.
      </div>
      <div
        style={{
          width: 40,
          height: 40,
          border: `4px solid ${theme.colors.primary}30`,
          borderTop: `4px solid ${theme.colors.primary}`,
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          marginTop: theme.spacing.lg,
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default SplashScreen; 